module.exports = __webpack_public_path__ + "static/media/calmos1.2641f3c5.png";